import { useNavigate } from "react-router-dom";
import { SearchInput } from "features";
import { Button } from "shared/ui/button";
import { NavigationSidebar } from "..";
import { useSidebar } from "shared/lib/hooks";
import { useMobile } from "shared/lib/hooks";
import { useActiveSection } from "shared/lib/hooks/useActiveSection";
import { HOME_ROUTE, LK_PROFILE_ROUTE } from "shared/config/routes";
import { LoginSidebar } from "features";
import { useUserStore } from "entities/user";
import { DisabledElementModal } from "widgets/disabled-element-modal";
import { useModal } from "shared/ui/modal";
import Loupe from "../assets/Loupe.svg";
import BurgerBtn from "shared/assets/images/Burger_btn.svg";
import Close from "shared/assets/images/Close.svg";
import Logo from "shared/assets/images/Logo.png";
import LogoSmall from "shared/assets/images/Logo_small.png";
import MapPin from "shared/assets/images/Map_pin.svg";
import Heart from "../assets/Heart.svg";
import ShoppingBag from "../assets/Shopping_bag.svg";
import User from "../assets/User.svg";
import HeartHover from "../assets/Heart-hover.svg";
import ShoppingBagHover from "../assets/Shopping_bag-hover.svg";
import UserHover from "../assets/User-hover.svg";
import styles from "./Header.module.scss";

export const Header = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useUserStore();

  const {
    isCollapsed: isNavigationSidebarCollapsed,
    open: openNavigationSidebar,
    close: closeNavigationSidebar,
    toggle: toggleNavigationSidebar,
  } = useSidebar(true);

  const {
    isCollapsed: isLoginSidebarCollapsed,
    open: openLoginSidebar,
    close: closeLoginSidebar,
    toggle: toggleLoginSidebar,
  } = useSidebar(true);

  const {
    isModalOpen: isDisabledElementModalOpen,
    open: openDisabledElementModal,
    close: closeDisabledElementModal,
    toggle: toggleDisabledElementModal,
  } = useModal(false);

  const isMobile = useMobile("950px");

  const sectionIds = ["about", "products", "brands", "blog"];
  const activeSection = useActiveSection(sectionIds);

  const handleBurgerClick = () => {
    if (isNavigationSidebarCollapsed && isLoginSidebarCollapsed) {
      openNavigationSidebar();
    } else {
      closeNavigationSidebar();
      closeLoginSidebar();
    }
  };

  const handleProfileClick = async () => {
    if (!isAuthenticated) {
      if (isLoginSidebarCollapsed) {
        openLoginSidebar();
      } else closeLoginSidebar();
      return;
    }

    navigate(LK_PROFILE_ROUTE);
  };

  return (
    <>
      {isMobile ? (
        <>
          <div className={styles.headerMobileContainer}>
            <div className={styles.buttons}>
              <Button
                variant="ghost"
                size="small"
                leftIcon={
                  <img
                    src={
                      isNavigationSidebarCollapsed && isLoginSidebarCollapsed
                        ? BurgerBtn
                        : Close
                    }
                    alt="burger btn"
                    height={26}
                  />
                }
                onClick={handleBurgerClick}
              />
            </div>
            <div className={styles.buttons}>
              <Button
                variant="ghost"
                size="small"
                leftIcon={<img src={Loupe} alt="loupe" height={26} />}
                onClick={openDisabledElementModal}
              />
            </div>
            <div className={styles.logo}>
              <a href={HOME_ROUTE}>
                <img src={LogoSmall} className={styles.logo__img} />
              </a>
            </div>
            <div className={styles.buttons}>
              <Button
                variant="ghost"
                size="small"
                leftIcon={<img src={Heart} alt="heart" height={26} />}
                onClick={openDisabledElementModal}
                data-left-icon-hover={HeartHover}
              />
            </div>
            <div className={styles.buttons}>
              <Button
                variant="ghost"
                size="small"
                leftIcon={
                  <img src={ShoppingBag} alt="shopping bag" height={26} />
                }
                onClick={openDisabledElementModal}
                data-left-icon-hover={ShoppingBagHover}
              />
            </div>
          </div>
          <NavigationSidebar
            isCollapsed={isNavigationSidebarCollapsed}
            open={openNavigationSidebar}
            close={closeNavigationSidebar}
            toggle={toggleNavigationSidebar}
            loginSidebarOpen={openLoginSidebar}
            loginSidebarClose={closeLoginSidebar}
            isLoginSidebarCollapsed={isLoginSidebarCollapsed}
          />
        </>
      ) : (
        <>
          <div className={styles.headerDesktopContainer}>
            <div className={styles.logo}>
              <a href="/">
                <img src={Logo} className={styles.logo__img} alt="Logo" />
              </a>
            </div>
            <div className={styles.centerBlock}>
              <div className={styles.search}>
                <SearchInput onDisabled={openDisabledElementModal} />
              </div>
              <div className={styles.links}>
                <a
                  href={`${HOME_ROUTE}#about`}
                  className={`${styles.links__link} ${activeSection === "about" ? styles.active : ""}`}
                >
                  О нас
                </a>
                <a
                  href={`${HOME_ROUTE}#products`}
                  className={`${styles.links__link} ${activeSection === "products" ? styles.active : ""}`}
                >
                  Каталог
                </a>
                <a
                  href={`${HOME_ROUTE}#brands`}
                  className={`${styles.links__link} ${activeSection === "brands" ? styles.active : ""}`}
                >
                  Бренды
                </a>
                <a
                  href={`${HOME_ROUTE}#blog`}
                  className={`${styles.links__link} ${activeSection === "blog" ? styles.active : ""}`}
                >
                  Новости
                </a>
                <a
                  className={styles.links__linkDisabled}
                  onClick={openDisabledElementModal}
                >
                  Контакты
                </a>
                <a
                  className={styles.links__linkDisabled}
                  onClick={openDisabledElementModal}
                >
                  Сертификаты
                </a>
              </div>
            </div>
            <div className={styles.buttons}>
              <Button
                variant="ghost"
                size="small"
                leftIcon={<img src={MapPin} alt="map pin" height={28} />}
                onClick={openDisabledElementModal}
              >
                Самара
              </Button>
              <Button
                variant="ghost"
                size="small"
                leftIcon={<img src={Heart} alt="heart" height={28} />}
                onClick={openDisabledElementModal}
                data-left-icon-hover={HeartHover}
              />
              <Button
                variant="ghost"
                size="small"
                leftIcon={
                  <img src={ShoppingBag} alt="shopping bag" height={28} />
                }
                onClick={openDisabledElementModal}
                data-left-icon-hover={ShoppingBagHover}
              />
              <Button
                variant="ghost"
                size="small"
                leftIcon={<img src={User} alt="user" height={28} />}
                data-left-icon-hover={UserHover}
                onClick={handleProfileClick}
              />
            </div>
          </div>
        </>
      )}
      <LoginSidebar
        isCollapsed={isLoginSidebarCollapsed}
        open={openLoginSidebar}
        close={closeLoginSidebar}
        toggle={toggleLoginSidebar}
        variant="homePage"
      />
      <DisabledElementModal
        isModalOpen={isDisabledElementModalOpen}
        open={openDisabledElementModal}
        close={closeDisabledElementModal}
        toggle={toggleDisabledElementModal}
      />
    </>
  );
};
